/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Model_Pricing_Included_Api_KeyInputs */



/**
* | output |
* | --- |
* | "Through an API key or the Microsoft Teams bot, per 1M tokens:" |
*
* @param {Model_Pricing_Included_Api_KeyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const model_pricing_included_api_key = /** @type {((inputs?: Model_Pricing_Included_Api_KeyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Model_Pricing_Included_Api_KeyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Über einen API-Schlüssel oder den Microsoft-Teams-Bot, pro 1 Mio. Tokens:")
	return /** @type {LocalizedString} */ ("Through an API key or the Microsoft Teams bot, per 1M tokens:")
});